import React from "react";
import { Form, Field } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { FaEdit, FaTrashAlt, FaSave, FaTimes } from "react-icons/fa";

const FORM_DATA_INDEX = "formDataIndex";
const DATA_ITEM_KEY = "id";

const validateEmail = (email) => {
  if (!email) return "";
  const atIndex = email.indexOf("@");
  const lastDotIndex = email.lastIndexOf(".");
  const isValidEmail = atIndex > 0 && lastDotIndex > atIndex;

  if (isValidEmail) {
    return "";
  } else {
    return "L'e-mail deve essere esempio@dominio.com";
  }
};

const validatePhoneNumber = (phone) => {
  if (!phone) return "";
  const re = /^[0-3][0-9]*$/;
  return !re.test(phone) ? "Il numero di telefono deve iniziare con 0 o 3" : "";
};

// const requiredValidator = (value, valueGetter, props) => {
//   console.log(value);
//   return "L'e-mail deve essere esempio@dominio.com";
// };
const TextInputWithValidation = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <Input {...others} />
      {visited && validationMessage && (
        <div role="alert" className="k-form-error k-text-start">
          {validationMessage}
        </div>
      )}
    </div>
  );
};
const FormSubmitContext = React.createContext(() => undefined);
const GridEditContext = React.createContext({});
const GridInlineFormRow = (props) => {
  const { onRowAction, editIndex } = React.useContext(GridEditContext);
  const isInEdit = props.dataItem[FORM_DATA_INDEX] === editIndex;
  const onSubmit = React.useCallback(
    (e) => {
      onRowAction({
        rowIndex: editIndex,
        operation: "save",
        dataItem: e,
      });
    },
    [onRowAction, editIndex]
  );
  if (isInEdit) {
    return (
      <Form
        key={JSON.stringify(props.dataItem)}
        initialValues={props.dataItem}
        onSubmit={onSubmit}
        render={(formRenderProps) => {
          return (
            <FormSubmitContext.Provider value={formRenderProps.onSubmit}>
              {props.children}
            </FormSubmitContext.Provider>
          );
        }}
      />
    );
  }
  return props.children;
};

const requiredValidator = (value, propertyName) => {
  switch (propertyName) {
    case "email":
      return validateEmail(value);
    case "phoneNumber":
      return validatePhoneNumber(value);
    case "contactName":
      return !value ? "Contact name is required" : "";
    default:
      return "";
  }
};
const NameCell = (props) => {
  const { editIndex } = React.useContext(GridEditContext);
  const isInEdit = props.dataItem[FORM_DATA_INDEX] === editIndex;
  console.log(props.field);
  return (
    <td>
      {isInEdit ? (
        <Field
          component={TextInputWithValidation}
          name={`${props.field}`}
          validator={(value) => requiredValidator(value, props.field)}
        />
      ) : (
        props.dataItem[props.field || ""]
      )}
    </td>
  );
};
const CommandCell = (props) => {
  const onSubmit = React.useContext(FormSubmitContext);
  const { onRowAction, setEditIndex, editIndex } = React.useContext(
    GridEditContext
  );
  const rowIndex = props.dataItem[FORM_DATA_INDEX];
  const isInEdit = rowIndex === editIndex;
  const isNewItem = !props.dataItem[DATA_ITEM_KEY];

  const onRemoveClick = React.useCallback(
    (e) => {
      e.preventDefault();
      onRowAction({
        rowIndex,
        operation: "remove",
      });
    },
    [rowIndex, onRowAction]
  );

  const onSaveClick = React.useCallback(
    (e) => {
      e.preventDefault();
      onSubmit(e);
    },
    [onSubmit]
  );

  const onEditClick = React.useCallback(
    (e) => {
      e.preventDefault();
      setEditIndex(rowIndex);
    },
    [rowIndex, setEditIndex]
  );

  const onCancelClick = React.useCallback(
    (e) => {
      e.preventDefault();
      onRowAction({
        rowIndex,
        operation: "cancel",
      });
      setEditIndex(undefined);
    },
    [onRowAction, rowIndex, setEditIndex]
  );

  return isInEdit ? (
    <td className="k-command-cell">
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
        style={{
          backgroundColor: "#007bff",
          color: "#fff",
          border: "1px solid #007bff",
        }}
        onClick={onSaveClick}
      >
        <FaSave /> {isNewItem ? "Add" : "Update"}
      </button>
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
        style={{
          backgroundColor: "#007bff",
          color: "#fff",
          border: "1px solid #007bff",
        }}
        onClick={isNewItem ? onRemoveClick : onCancelClick}
      >
        <FaTimes /> {isNewItem ? "Discard" : "Cancel"}
      </button>
    </td>
  ) : (
    <td className="k-command-cell">
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary k-grid-edit-command"
        style={{
          backgroundColor: "#007bff",
          color: "#fff",
          border: "1px solid #007bff",
        }}
        onClick={onEditClick}
      >
        <FaEdit /> Edit
      </button>
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command"
        style={{
          backgroundColor: "#007bff",
          color: "#fff",
          border: "1px solid #007bff",
        }}
        onClick={onRemoveClick}
      >
        <FaTrashAlt /> Remove
      </button>
    </td>
  );
};
const rowRender = (row, props) => {
  return <GridInlineFormRow dataItem={props.dataItem}>{row}</GridInlineFormRow>;
};

export {
  GridEditContext,
  CommandCell,
  NameCell,
  rowRender,
  FORM_DATA_INDEX,
  DATA_ITEM_KEY,
};
